module.exports = __webpack_public_path__ + "img/horizontal_3_2_1.a84ee0b2.png";